import React, { createContext, useState } from 'react';

// Create the context
export const HeadingContext = createContext();

// Create a provider component
export const HeadingProvider = ({ children }) => {
  const [heading, setHeading] = useState('Organization');

  return (
    <HeadingContext.Provider value={{ heading, setHeading }}>
      {children}
    </HeadingContext.Provider>
  );
};